import {Props} from './model';
import {View} from 'react-native';
import * as React from 'react';
import {useStyles} from '../../../../shared/hooks/styles';
import {Modal} from '../../../../shared/components/modal/modal';
import {PollVoteResult} from '../pollVoteResult';

export default ({poll, onClose, isVoteCompleteNow}: Props) => {
  const styles = useStyles(() => ({
    modalWrap: {
      paddingVertical: 0,
      paddingHorizontal: 0,
    },
    modalTitle: {display: 'none'},
    contentWrapper: {
      paddingHorizontal: 100,
      paddingTop: 40,
      paddingBottom: 40,
    },
    modalContent: {
      paddingTop: 0,
      width: 802,
      maxWidth: '100%',
    },
  }));
  return (
    <Modal
      contentStyle={styles.modalContent}
      wrapStyle={styles.modalWrap}
      titleStyle={styles.modalTitle}
      onClose={onClose}>
      <View style={styles.contentWrapper}>
        <PollVoteResult poll={poll} isVoteCompleteNow={isVoteCompleteNow} />
      </View>
    </Modal>
  );
};
